export default __webpack_public_path__ + "static/media/tenplus.d8b3af0c.png";